<template>
    <div class="col-md-12">
        <div class="panel panel-visible" id="spy2">

            <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"/>

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"></span>Абонементы</div>
            </div>
            <div class="panel-body pn">
                <per-pager v-bind:per-page="pagination.perPage"/>
                <table class="table table-striped table-hover datatables">
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>Клиент</th>
                            <th>Абонемент</th>
                            <th>Остаток</th>
                            <th>Активность</th>
                            <th>Дата активации</th>
                            <th>Дата окончания</th>
                            <th>Дата продажи</th>
                            <th>Автор</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(subscription, index) in subscriptions" v-bind:key="index">
                            <td>{{subscription.id}}</td>
                            <td>
                                <router-link v-if="subscription.client" :to="{name: 'clients-edit', params: {id: subscription.clientId}}">
                                    {{subscription.client.fullName}}
                                </router-link>
                            </td>
                            <td>{{subscription.subscription.name}}</td>
                            <td>{{subscription.count}}</td>
                            <td class="text-center">
                                <span class="label" :class="{'label-system': subscription.status === 1, 'label-default': subscription.status === 0}">
                                    <i class="glyphicon glyphicon-flash"></i>
                                </span>
                            </td>
                            <td>
                                <span v-if="subscription.status === 1">
                                    {{subscription.dateActivate | dateFormat('dd.mm.yyyy')}}
                                </span>
                                <span v-else>
                                    <button type="button" v-on:click="activate(subscription)" class="btn btn-xs btn-warning">Активировать</button>
                                </span>
                            </td>
                            <td>
                                <span v-if="subscription.status === 1">
                                    {{subscription.dateExpire | dateFormat('dd.mm.yyyy')}}
                                </span>
                                <span v-else>
                                    ---
                                </span>
                            </td>
                            <td>{{subscription.createdAt | dateFormatTimestamp('dd.mm.yyyy')}}</td>
                            <td>{{subscription.createdBy ? data.users.find(user => user.id === subscription.createdBy).fullName : '---'}}</td>
                        </tr>
                    </tbody>
                </table>
                <paginator v-bind="pagination"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Subscription from "../../../models/ClientSubscription";
    import User from "../../../models/User";
    import dateformat from 'dateformat';

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
            Paginator: () => import('../../data/Paginator'),
            PerPager: () => import('../../data/PerPager'),
        },
        beforeMount() {
            this.load();
        },
        beforeRouteUpdate(to, from, next) {
            next();
            this.load();
        },
        data() {
            return {
                data: {
                    users: [],
                },
                isLoading: false,
                pagination: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 0,
                    totalCount: 0,
                },
                subscriptions: [],
            };
        },
        watch: {
            'pagination.perPage': function(value) {
                this.setDefaultPerPage(value);
            },
        },
        methods: {
            async load() {
                this.isLoading = true;

                const users = await User.getList(1, 999);
                this.data.users = users.data;

                const page = this.$route.query.page ? this.$route.query.page : 1;
                const perPage = this.$route.query['per-page'] ? this.$route.query['per-page'] : this.getDefaultPerPage();

                const subscriptionResponse = await Subscription.getList(page, perPage, '-id', ['client', 'subscription']);
                this.setData(subscriptionResponse.data, subscriptionResponse.headers);

                this.isLoading = false;
            },
            getDefaultPerPage() {
                if (this.$store.state.template.perPages['subscriptions-list']) {
                    return this.$store.state.template.perPages['subscriptions-list'];
                }
                return 25;
            },
            setDefaultPerPage(value) {
                this.$store.commit('template/setPerPage', {name: 'subscriptions-list', value: value})
            },
            setData(subscriptions, headers) {
                this.subscriptions = subscriptions;
                this.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.pagination.totalCount = Number(headers['x-pagination-total-count']);
            },
            async activate(subscription) {
                if (confirm(`Активировать абонемент\n${subscription.subscription.name} для ${subscription.client.fullName}`) === false) {
                    return;
                }
                this.isLoading = true;

                await subscription.activate();
                subscription.status = Subscription.STATUS_ACTIVE;
                subscription.dateActivate = dateformat(new Date(), 'yyyy-mm-dd');

                this.isLoading = false;
            },
        },
        metaInfo() {
            return {
                title: 'Клиенты - список абонементов',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
